import { state, getters, mutations } from '../machines/mutations';
import { actions } from '../machines/actions';

export default {
    state,
    actions,
    mutations,
    getters
}